module.exports = __webpack_public_path__ + "img/lighting.c78dc335.png";